import Loader from '@/components/Loader';
import EditableString from '@/components/ui/EditableString';
import useSiteSearch from '@/hooks/useSiteSearch';
import ZipCodeActiveCard from '@/pages/setup/account/zipcode/ZipCodeActiveCard';
import ZipCodeInactiveCard from '@/pages/setup/account/zipcode/ZipCodeInactiveCard';
import {useUser} from '@lore/auth';
import {useQueryMutation} from '@lore/query-connect';
import React, {useState} from 'react';
import OrganizationSection from './OrganizationSection';
import SchoolSection from './SchoolSection';

export default function LocationSection() {
  const currentUser = useUser();
  const {zipCode} = currentUser.data;

  const {total: siteCount, city, state, isLoading: isSearching} = useSiteSearch({
    zipCode,
    isActive: true,
    countOnly: true,
    enabled: zipCode?.length >= 5,
  });

  const userMutation = useQueryMutation('currentUser.updateSingleton', currentUser);

  const [isEditingZip, setIsEditingZip] = useState(false);
  const [savedZip, setSavedZip] = useState(zipCode);
  const [editableZip, setEditableZip] = useState(zipCode);

  function onEditZip() {
    setEditableZip(savedZip);
    setIsEditingZip(true);
  }

  function onCancelZip() {
    setEditableZip(savedZip);
    setIsEditingZip(false);
  }

  async function onSaveZip() {
    setSavedZip(editableZip);
    await userMutation.mutateAsync({zipCode: editableZip});
    setIsEditingZip(false);
  }

  const zipIsActive = siteCount > 0;
  const showZipCards = zipCode?.length >= 5;

  return (
    <section id="location" className="py-8">
      {/*<pre>{JSON.stringify(currentUser?.data?.zipCode,null,2)}</pre>*/}
      {/*<pre>{JSON.stringify(currentUser?.data?.sites,null,2)}</pre>*/}
      <h2 className="mb-8 text-2xl font-semibold text-cs-gray-900">Location</h2>

      <div className="space-y-10">
        <div className="grid gap-8 lg:grid-cols-[280px_1fr]">
          <EditableString
            label="ZIP code"
            value={isEditingZip ? editableZip : savedZip}
            isEditing={isEditingZip}
            onEdit={onEditZip}
            onChange={setEditableZip}
            onCancel={onCancelZip}
            onSave={onSaveZip}
            saveDisabled={editableZip?.length < 5}
            editAriaLabel="Edit ZIP code"
          />
          {showZipCards && (
            isSearching ? (
              <div className="flex items-center justify-center">
                <Loader/>
              </div>
            ) : zipIsActive
              ? <ZipCodeActiveCard city={city} state={state}/>
              : <ZipCodeInactiveCard city={city} state={state}/>
          )}
        </div>

        <SchoolSection/>

        <OrganizationSection/>
      </div>
    </section>
  );
}
